import MuiPaper, { type PaperProps } from "@mui/material/Paper";

export type { PaperProps };

export function Paper(props: PaperProps) {
  return <MuiPaper {...props} />;
}
